/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-nested-ternary */
import React, { useEffect } from "react";
import {
  CompartilhadosInterface,
  useResponsaveis,
  useTransferirV1,
} from "services/api";
import InputCommon from "components/inputCommon";
import { useTransformList } from "hooks/objectToLabelValue";
import FormatDate from "utils/formatDate";
import { RootStateOrAny, useSelector } from "react-redux";
import { IconButton, Modal } from "@mui/material";
import { toast } from "react-toastify";
import DialogCommon from "components/dialogCommon";
import DesqualifyForm from "components/dialogCommon/templates/desqualifyForm";
import { useListarUsuariosCorretores } from "services/api/Identity_Usuario/listar-usuarios-corretores";
import { CustomOption } from "components/customOption";
import cyrelaLogo from "../../../../../assets/bandeiras/cyrelalogo.png";
import * as Styles from "./styles";
import MaterialUI from "../../../../../material-UI";
import { AuthState } from "../../../../../store/ducks/auth/types";
import * as SVGIcons from "../../../../../assets/iconsSVG";
import DeleteShareModal from "../../../../../components/dialogCommon/templates/DeleteShareModal";
import ConfirmModal from "../../../../../components/dialogCommon/templates/confirmModal";

interface Props {
  idLead: string | undefined;
  idLeadCorretor: string | undefined;
  idCorretorLead: string | undefined;
  tabValue: number;
  onOpenShare: () => void;
  isOrigemCyrela: boolean;
}

export function ResponsaveisSection(props: Props) {
  const { codigoCargo2013, idCorretorSistemaOrigem } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);
  const isCorretor = codigoCargo2013 === "219.840.002";
  const [openDeleteShare, setOpenDeleteShare] = React.useState(false);
  const [removerCompartilhamentoModal, setRemoverCompartilhamentoModal] =
    React.useState(false);

  const { data, refetch: refetchResponsaveis } = useResponsaveis({
    idLeadCorretor: props?.idLeadCorretor,
    queryKey: "responsaveis-lead-details",
  });
  const [deleteShareData, setDeleteShareData] =
    React.useState<CompartilhadosInterface | null>(null);

  const [disqualify, setDisqualify] = React.useState(false);

  const [motivo, setMotivo] = React.useState("");
  const leadEncontrado: any = data?.compartilhados?.find(
    (item: any) => item?.idCorretorAtual === idCorretorSistemaOrigem
  );
  const leadEncontradoGerente: any = data?.compartilhados;

  React.useEffect(() => {
    if (isCorretor) {
      setDeleteShareData(leadEncontrado);
    } else {
      setDeleteShareData(leadEncontradoGerente);
    }
  }, [leadEncontrado]);

  React.useEffect(() => {
    if (props.tabValue === 2) {
      refetchResponsaveis();
    }
  }, [props.tabValue]);

  const [value, setValue] = React.useState({
    label: "",
    value: "",
  });

  const {
    data: dataCorretores,
    refetch: refetchCorretores,
    isRefetching: isRefetchingDataCorretores,
  } = useListarUsuariosCorretores({
    queryKey: "listar-corretores-equipe",
  });

  const transformedListCorretores = useTransformList({
    inputList: dataCorretores?.data,
    labelField: "apelido",
    valueField: "idCorretor",
  });

  React.useEffect(() => {
    refetchCorretores();
  }, []);

  const { mutate, isLoading, isSuccess } = useTransferirV1({
    leads: [
      {
        idLead: props.idLead,
        idLeadCorretor: props.idLeadCorretor,
        idCorretorLead: props.idCorretorLead,
      },
    ],
    idCorretorDestino: value.value,
    descricaoMotivoTransferencia: motivo,
  });

  const handleTransferir = async () => {
    if (value.value === "") {
      toast.warn("Selecione um corretor de destino.");
    } else {
      mutate();
    }
  };

  useEffect(() => {
    if (isSuccess) {
      window.location.href = "/transferencia-concluida/transferido";
    }
  }, [isSuccess]);

  const isThisLeadMine = idCorretorSistemaOrigem === props.idCorretorLead;

  // lista principal dos leads compartilhados, verifica se o lead nao é do usuario e se o usuario é corretor,
  //  caso seja verdade quer dizer que o lead nao é dele e foi compartilhado com ele,
  // sendo assim deve listar somente a option que contem o nome dele
  const principalList =
    !isThisLeadMine && isCorretor ? [leadEncontrado] : data?.compartilhados;

  return (
    <>
      <Styles.Container>
        <Styles.Title>Responsáveis</Styles.Title>
        <Styles.SubTitle>
          Aqui você pode ver os responsáveis pelo lead, quem está trabalhando o
          lead e o corretor de origem.
        </Styles.SubTitle>
        <Styles.CardResponsaveisContainer>
          <Styles.CardResponsaveis>
            <Styles.CardResponsaveisImg
              alt="Imagem do corretor dono do lead"
              src={
                data?.corretorResponsavel?.foto ||
                "https://cdn.discordapp.com/attachments/1082297301072105544/1144683528785772564/image.png"
              }
            />
            <div>
              <Styles.Title style={{ color: "#000000" }}>
                {data?.corretorResponsavel?.nome}
              </Styles.Title>
              <Styles.SubTitle style={{ color: "#828282" }}>
                Dono do lead
              </Styles.SubTitle>
            </div>
          </Styles.CardResponsaveis>
          <Styles.CardResponsaveis>
            {props.isOrigemCyrela ? (
              <>
                <Styles.CardResponsaveisImg
                  alt="Cyrela logo"
                  src={cyrelaLogo}
                />
                <div>
                  <Styles.SubTitle>
                    Lead prospectado pelo Grupo Cyrela
                  </Styles.SubTitle>
                </div>
              </>
            ) : (
              <>
                <Styles.CardResponsaveisImg
                  alt="Imagem do corretor de origem"
                  src={
                    data?.corretorOrigem?.foto ||
                    "https://cdn.discordapp.com/attachments/1082297301072105544/1144683528785772564/image.png"
                  }
                />
                <div>
                  <Styles.Title style={{ color: "#000000" }}>
                    {data?.corretorOrigem?.nome}
                  </Styles.Title>
                  <Styles.SubTitle style={{ color: "#828282" }}>
                    Corretor de origem
                  </Styles.SubTitle>
                </div>
              </>
            )}
          </Styles.CardResponsaveis>
        </Styles.CardResponsaveisContainer>
        <Styles.Title style={{ fontSize: "18px" }}>
          Compartilhado com{!isThisLeadMine && isCorretor ? " você" : ""}
        </Styles.Title>
        {!isThisLeadMine && isCorretor ? (
          <></>
        ) : (
          <Styles.SubTitle style={{ fontSize: "13px" }}>
            Você pode compartilhar seu lead com outro corretor. Ele poderá
            editar informações e atualizar este lead, mas isso tudo irá ficar
            registrado no histórico. Você pode encerrar esse compartilhamento a
            qualquer momento.
          </Styles.SubTitle>
        )}
        <Styles.BodyTable>
          <Styles.HeaderTable>
            <div className="col col-1">
              <p>Corretor</p>
            </div>
            <div className="col col-2">
              <p>Compartilhado em</p>
            </div>
            <div className="col col-3">
              <p>Compartilhado por</p>
            </div>
            {isCorretor ? (
              <div className="col col-4">
                <p>Ação</p>
              </div>
            ) : null}
          </Styles.HeaderTable>

          {data?.compartilhados && (
            <>
              <Styles.ItemsList
                style={
                  data?.compartilhados?.length > 4
                    ? { overflowY: "scroll" }
                    : { overflowY: "auto" }
                }
              >
                {data?.compartilhados?.length === 0 ? (
                  <>
                    <p
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        fontFamily: "Inter",
                        color: "#686775",
                        fontWeight: "bold",
                        fontSize: 14,
                        marginBottom: 20,
                      }}
                    >
                      Nenhum registro encontrado
                    </p>
                  </>
                ) : (
                  <>
                    {principalList?.map((item: CompartilhadosInterface) => (
                      <>
                        <Styles.Item>
                          <div className="col col-1">
                            <p>{item?.corretorAtual ?? "--"}</p>
                          </div>
                          <div className="col col-2">
                            <p>{FormatDate(item?.compartilhadoEm)}</p>
                          </div>
                          <div className="col col-3">
                            <p>{item?.compartilhadoPor ?? "--"}</p>
                          </div>
                          <IconButton
                            onClick={() => {
                              setDeleteShareData(item);
                              setOpenDeleteShare(true);
                            }}
                            style={{ backgroundColor: "#ffe4e4" }}
                          >
                            <SVGIcons.DeleteIconRed />
                          </IconButton>
                        </Styles.Item>
                      </>
                    ))}
                  </>
                )}
              </Styles.ItemsList>
            </>
          )}
        </Styles.BodyTable>

        {!isThisLeadMine && isCorretor ? (
          <Styles.ButtonSend
            style={{ backgroundColor: "#eb3d3d" }}
            disabled={isLoading}
            onClick={() => {
              setDeleteShareData(leadEncontrado);
              setOpenDeleteShare(true);
            }}
          >
            Remover compartilhamento
          </Styles.ButtonSend>
        ) : null}

        {data?.corretorResponsavel?.id === idCorretorSistemaOrigem ? (
          <>
            <Styles.ButtonTransfer onClick={() => props?.onOpenShare()}>
              {"Novo compartilhamento"}
            </Styles.ButtonTransfer>
            <Styles.Title style={{ fontSize: "18px" }}>
              Transferir lead
            </Styles.Title>
            <Styles.SubTitle style={{ fontSize: "13px" }}>
              Cuidado! Se você transferir seu lead, você não terá mais acesso a
              ele na sua carteira!
            </Styles.SubTitle>
            <Styles.Autocomplete
              id="combo-box-demo"
              options={transformedListCorretores}
              renderInput={(params: any) => (
                <>
                  <Styles.LabelText>Corretor de destino</Styles.LabelText>
                  <Styles.TextField
                    size="small"
                    InputLabelProps={{ shrink: false }}
                    variant="outlined"
                    {...params}
                    label="Corretor de destino"
                  />
                </>
              )}
              getOptionSelected={(option: any) => option?.label || ""}
              getOptionLabel={(option: any) => option?.label || ""}
              onChange={(event, newValue: any) => {
                setValue(
                  newValue !== null ? newValue : { label: "", value: "" }
                );
              }}
            />
            <Styles.LabelText style={{ marginBottom: "-10px" }}>
              Motivo
            </Styles.LabelText>
            <InputCommon
              isDisabled={false}
              isError={false}
              type="observacao"
              maxLengthProps={500}
              label=""
              value={motivo}
              row={4}
              multiline
              onChange={(value: string) => setMotivo(value)}
            />
            <Styles.ButtonSend disabled={isLoading} onClick={handleTransferir}>
              {isLoading ? <MaterialUI.CircularProgress /> : "Transferir"}
            </Styles.ButtonSend>
            <Styles.ButtonSend
              style={{ backgroundColor: "#eb3d3d" }}
              disabled={isLoading}
              onClick={() => setDisqualify(true)}
            >
              Desqualificar
            </Styles.ButtonSend>
          </>
        ) : null}
      </Styles.Container>
      <Modal open={openDeleteShare} onClose={() => setOpenDeleteShare(false)}>
        <DeleteShareModal
          closeModal={() => {
            setOpenDeleteShare(false);
            setDeleteShareData(null);
          }}
          refresh={() => refetchResponsaveis()}
          idLeadCorretor={props?.idLeadCorretor}
          idLead={props?.idLead}
          deleteShareData={deleteShareData}
          idLeadResponsavel={data?.corretorResponsavel?.id}
          idCorretorSistemaOrigem={idCorretorSistemaOrigem}
        />
      </Modal>
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setDisqualify}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        title="Desqualificar"
        isFilter={false}
        isClose
        width={500}
        component={
          <DesqualifyForm
            idLead={props?.idLead}
            idLeadCorretor={props?.idLeadCorretor || ""}
            onClose={setDisqualify}
            open={disqualify}
            isLeadScreen
            hotRefreshFunc={() => {
              /* eslint-disable */
              console.log("Atualizar");
            }}
          />
        }
        setOpenModal={setDisqualify}
        open={disqualify}
        icon={<SVGIcons.DesqualifyLeadIcon />}
      />
    </>
  );
}
